// @flow

export const debounce = (
  func: (...args: Array<any>) => any,
  interval: number,
) => {
  let timer = null;
  return (...args: Array<any>) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), interval);
  };
};
